export default {
      id: "ic-success-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-success-usage",
      toString: function () {
        return this.url;
      }
    }